module.exports = __webpack_public_path__ + "img/attendanceHistory.6d27f4b1.svg";